"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[254],{

/***/ 28254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(86946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./src/utils/use-is-mobile.ts
var use_is_mobile = __webpack_require__(11679);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/static-import-icon.tsx + 34 modules
var static_import_icon = __webpack_require__(75340);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 2 modules
var useTrans = __webpack_require__(74069);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/footer/footer.desktop.tsx






const FooterDesktop = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "w-full bg-black/40 py-4 relative z-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                className: "w-full flex-col sm:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: {
                            sm: "column",
                            md: "row"
                        },
                        justifyContent: "center",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                "data-testid": "footer-copyright",
                                variant: "body2",
                                color: "textSecondary",
                                children: "\xa9 2023 Renec Foundation. All rights reserved."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/terms-and-conditions",
                                variant: "body2",
                                color: "textSecondary",
                                children: trans.terms_of_use
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        "data-testid": "social-links-wrapper",
                        direction: "row",
                        justifyContent: "end",
                        alignItems: "center",
                        spacing: 3,
                        className: "mt-3 sm:mt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: static_import_icon/* IconName.DISCORD */.u.DISCORD,
                                    placement: "top",
                                    TransitionComponent: Fade/* default */.Z,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        "data-testid": "social-link-discord",
                                        href: "https://discord.gg/JNvaFP5QCz",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.DISCORD */.u.DISCORD),
                                            alt: static_import_icon/* IconName.DISCORD */.u.DISCORD,
                                            width: 24
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: static_import_icon/* IconName.REDDIT */.u.REDDIT,
                                    placement: "top",
                                    TransitionComponent: Fade/* default */.Z,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        "data-testid": "social-link-reddit",
                                        href: "https://www.reddit.com/r/renecblockchain/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.REDDIT */.u.REDDIT),
                                            alt: static_import_icon/* IconName.REDDIT */.u.REDDIT,
                                            width: 24
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: static_import_icon/* IconName.TWITTER */.u.TWITTER,
                                    placement: "top",
                                    TransitionComponent: Fade/* default */.Z,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        "data-testid": "social-link-twitter",
                                        href: "https://twitter.com/NemoSwapDEX",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TWITTER */.u.TWITTER),
                                            alt: static_import_icon/* IconName.TWITTER */.u.TWITTER,
                                            width: 24
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: static_import_icon/* IconName.TELEGRAM */.u.TELEGRAM,
                                    placement: "top",
                                    TransitionComponent: Fade/* default */.Z,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        "data-testid": "social-link-telegram",
                                        href: "https://t.me/nemoswapdex",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TELEGRAM */.u.TELEGRAM),
                                            alt: static_import_icon/* IconName.TELEGRAM */.u.TELEGRAM,
                                            width: 24
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_desktop = (/*#__PURE__*/(0,react.memo)(FooterDesktop));

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MoreHoriz.js
var MoreHoriz = __webpack_require__(79369);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(17417);
// EXTERNAL MODULE: ./node_modules/next/navigation.js
var navigation = __webpack_require__(39332);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/use-amplitude.ts + 61 modules
var use_amplitude = __webpack_require__(54341);
;// CONCATENATED MODULE: ./src/layouts/components/MenuLink.tsx








const MenuLink = (param)=>{
    let { activeHref , ...props } = param;
    const amplitude = (0,use_amplitude/* default */.Z)();
    const pathname = (0,navigation.usePathname)();
    const isMobile = (0,use_is_mobile/* useIsMobile */.d)();
    const selectedActiveHref = activeHref || props.href;
    const isExactMatch = pathname === selectedActiveHref // example / or /deposit
    ;
    const isPartialMatch = selectedActiveHref !== "/" && (pathname === null || pathname === void 0 ? void 0 : pathname.startsWith("".concat(selectedActiveHref, "/")) // example /deposit/1245
    );
    const isActive = isExactMatch || isPartialMatch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        color: "secondary",
        component: (link_default()),
        onClick: ()=>{
            amplitude.track(use_amplitude/* EVENT_NAMES.page_select_header_menu */.K.page_select_header_menu, {
                // remove first slash and replace other slashes as dashes
                menu_name: (selectedActiveHref === null || selectedActiveHref === void 0 ? void 0 : selectedActiveHref.replace(/^\//, "").replace(/\//g, "-")) || "home"
            });
        },
        ...props,
        className: classnames_default()("menu-link text-sm no-underline sm:text-base whitespace-nowrap hover:opacity-80 p-2", props.className, {
            "font-bold menu-link--active": isActive,
            "rounded-[100px] bg-[#1E2735]": isActive && isMobile
        })
    });
};
/* harmony default export */ var components_MenuLink = (MenuLink);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/MainMenuItems.tsx





const MainMenuItems = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                    href: "/",
                    "data-testid": "header-trade",
                    children: trans.header.trade
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                    href: "/assets",
                    "data-testid": "header-assets",
                    activeHref: "/assets",
                    children: trans.header.assets
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                    href: "/liquidity/browse",
                    activeHref: "/liquidity",
                    "data-testid": "header-nav-liquidity",
                    children: trans.header.liquidity
                })
            })
        ]
    });
};
/* harmony default export */ var components_MainMenuItems = (MainMenuItems);

// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(23599);
// EXTERNAL MODULE: ./src/contexts/pending-transactions.tsx + 2 modules
var pending_transactions = __webpack_require__(97181);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/ExtendedMenuItems.tsx






const ExtendedMenuItems = (param)=>{
    let { handleClose  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const { isDisplayPendingBadge , pendingTransactions  } = (0,react.useContext)(pending_transactions/* PendingTransactionsCtx */.F);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
            onClick: handleClose,
            disableRipple: true,
            className: "p-0 items-stretch justify-items-stretch",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MenuLink, {
                className: "flex items-center py-[6px] px-[16px] w-full",
                href: "/history",
                "data-testid": "header-nav-history",
                children: [
                    trans.header.transactions,
                    isDisplayPendingBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-[3px] inline-block h-4 min-w-[16px] bg-[#FF6701] rounded-full font-bold text-center text-xs pointer-events-none px-[3px]",
                        children: pendingTransactions.length
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_ExtendedMenuItems = (/*#__PURE__*/(0,react.memo)(ExtendedMenuItems));

;// CONCATENATED MODULE: ./src/layouts/MainLayout/footer/footer.mobile.tsx




















const FooterMobile = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const [anchorEl, setAnchorEl] = (0,react.useState)(null);
    const ref = (0,react.useRef)();
    const open = Boolean(anchorEl);
    const { isDisplayPendingBadge , pendingTransactions  } = (0,react.useContext)(pending_transactions/* PendingTransactionsCtx */.F);
    const handleClick = ()=>{
        setAnchorEl(anchorEl ? null : ref.current);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "w-full fixed z-10 bottom-[8px]",
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                onClickAway: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: "bg-[#121823] rounded-[28px] p-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainMenuItems, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "relative",
                                children: [
                                    isDisplayPendingBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "absolute h-4 min-w-[16px] bg-[#FF6701] rounded-full font-bold text-center text-xs pointer-events-none px-[3px] top-[-8px] left-[50%] translate-x-[-50%]",
                                        children: pendingTransactions.length
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreHoriz/* default */.Z, {
                                        "data-testid": "btn-extra-menu",
                                        onClick: handleClick,
                                        className: classnames_default()("sm:block cursor-pointer opacity-80 hover:opacity-100", open && "opacity-100")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                            open: open,
                            anchorEl: ref.current,
                            placement: "top",
                            className: "z-10 w-full px-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "bg-[#1E2735] rounded-[16px] border border-[#61667E] p-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExtendedMenuItems, {
                                        handleClose: handleClose
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        "data-testid": "social-links-wrapper",
                                        direction: "row",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        spacing: 3,
                                        className: "px-4 py-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: static_import_icon/* IconName.DISCORD_MOBILE */.u.DISCORD_MOBILE,
                                                    placement: "top",
                                                    TransitionComponent: Fade/* default */.Z,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        "data-testid": "social-link-discord",
                                                        href: "https://discord.gg/JNvaFP5QCz",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.DISCORD_MOBILE */.u.DISCORD_MOBILE),
                                                            alt: static_import_icon/* IconName.DISCORD_MOBILE */.u.DISCORD_MOBILE,
                                                            width: 24
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: static_import_icon/* IconName.REDDIT_MOBILE */.u.REDDIT_MOBILE,
                                                    placement: "top",
                                                    TransitionComponent: Fade/* default */.Z,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        "data-testid": "social-link-reddit",
                                                        href: "https://www.reddit.com/r/renecblockchain/",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.REDDIT_MOBILE */.u.REDDIT_MOBILE),
                                                            alt: static_import_icon/* IconName.REDDIT_MOBILE */.u.REDDIT_MOBILE,
                                                            width: 24
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: static_import_icon/* IconName.TWITTER_MOBILE */.u.TWITTER_MOBILE,
                                                    placement: "top",
                                                    TransitionComponent: Fade/* default */.Z,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        "data-testid": "social-link-twitter",
                                                        href: "https://twitter.com/NemoSwapDEX",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TWITTER_MOBILE */.u.TWITTER_MOBILE),
                                                            alt: static_import_icon/* IconName.TWITTER_MOBILE */.u.TWITTER_MOBILE,
                                                            width: 24
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: static_import_icon/* IconName.TELEGRAM_MOBILE */.u.TELEGRAM_MOBILE,
                                                    placement: "top",
                                                    TransitionComponent: Fade/* default */.Z,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        "data-testid": "social-link-telegram",
                                                        href: "https://t.me/nemoswapdex",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TELEGRAM_MOBILE */.u.TELEGRAM_MOBILE),
                                                            alt: static_import_icon/* IconName.TELEGRAM_MOBILE */.u.TELEGRAM_MOBILE,
                                                            width: 24
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        className: "px-2 py-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        spacing: 2,
                                        className: "py-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                "data-testid": "footer-copyright",
                                                variant: "body2",
                                                color: "textSecondary",
                                                textAlign: "center",
                                                children: "\xa9 2023 Renec Foundation. All rights reserved."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "/terms-and-conditions",
                                                variant: "body2",
                                                color: "textSecondary",
                                                children: trans.terms_of_use
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var footer_mobile = (FooterMobile);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/footer/index.tsx




const Footer = ()=>{
    const isMobile = (0,use_is_mobile/* useIsMobile */.d)();
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_mobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_desktop, {});
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(42293);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@renec-foundation/wallet-adapter-react/src/index.ts + 245 modules
var src = __webpack_require__(33731);
// EXTERNAL MODULE: ./src/constants/amplitude.ts
var constants_amplitude = __webpack_require__(78017);
// EXTERNAL MODULE: ./src/providers/wallet-balances/index.tsx
var wallet_balances = __webpack_require__(1706);
;// CONCATENATED MODULE: ./src/wallet/ui/WalletBalances.tsx




const WalletBalances = ()=>{
    const { userBalances  } = (0,react.useContext)(wallet_balances/* WalletBalancesContext */.S);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        display: "none",
        children: Object.keys(userBalances).map((tokenSymbol)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                "data-testid": "wallet-has-".concat(tokenSymbol),
                "data-amount": userBalances[tokenSymbol]
            }, tokenSymbol);
        })
    });
};
/* harmony default export */ var ui_WalletBalances = (WalletBalances);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/ConnectWallet.tsx








const WalletMultiButtonDynamic = dynamic_default()(// async () => (await import('@solana/wallet-adapter-react-ui')).WalletMultiButton,
async ()=>(await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33731))).WalletMultiButton, {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33731)
            ]
    },
    ssr: false
});
const ConnectWallet = ()=>{
    const amplitude = (0,use_amplitude/* default */.Z)();
    const trans = (0,useTrans/* default */.Z)();
    const { publicKey  } = (0,src.useWallet)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        onClick: ()=>{
            if (!publicKey) {
                amplitude.track(constants_amplitude/* EVENT_NAMES.page_connect_wallet_on_header */.K.page_connect_wallet_on_header);
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletMultiButtonDynamic, {
                className: "btn-border-gradient h-[36px] rounded-[100px] px-4 py-2 text-sm normal-case",
                children: !publicKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "wallet-adapter-button-content",
                    children: trans.common.connect_wallet
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_WalletBalances, {})
        ]
    });
};
/* harmony default export */ var components_ConnectWallet = (ConnectWallet);

// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
;// CONCATENATED MODULE: ./src/assets/svgs/world_icon.svg
/* harmony default export */ var world_icon = ({"src":"/_next/static/media/world_icon.7e9be524.svg","height":32,"width":32});
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 7 modules
var Menu = __webpack_require__(63375);
;// CONCATENATED MODULE: ./src/hooks/use-observed-ref.ts

const mutationListeners = (()=>{
    const listeners = [];
    try {
        const observer = new MutationObserver((mutations)=>{
            for (const listener of listeners){
                setTimeout(()=>listener(mutations));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    } catch (err) {}
    return listeners;
})();
const pushIfNotFound = function(arr, value) {
    let newArrayIfChanged = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const valueIndex = arr.indexOf(value);
    if (valueIndex === -1) {
        if (newArrayIfChanged) {
            arr = [
                ...arr
            ];
        }
        arr.push(value);
    }
    return arr;
};
const spliceIfFound = function(arr, value) {
    let newArrayIfChanged = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const valueIndex = arr.indexOf(value);
    if (valueIndex !== -1) {
        if (newArrayIfChanged) {
            arr = [
                ...arr
            ];
        }
        arr.splice(valueIndex, 1);
    }
    return arr;
};
/**
 * Creates a callback ref object and tracks when it gets added to or removed from
 * the DOM.
 */ const useObservedRef = (forwardedRef)=>{
    const [addListeners, setAddListeners] = (0,react.useState)([]);
    const [removeListeners, setRemoveListeners] = (0,react.useState)([]);
    const nodeRef = (0,react.useRef)(null);
    const [lastValidNode, setLastValidNode] = (0,react.useState)(null);
    (0,react.useImperativeHandle)(forwardedRef, ()=>nodeRef.current);
    const ref = (0,react.useCallback)((node)=>{
        nodeRef.current = node;
        if (node) {
            setLastValidNode(node);
        }
    }, []);
    const onAddedToDOM = (0,react.useCallback)((listener)=>{
        const mutationListener = (mutations)=>{
            if (mutations.filter((mutation)=>Array.from(mutation.addedNodes).some((node)=>node.isEqualNode(nodeRef.current))).length) {
                listener(nodeRef.current);
            }
        };
        setAddListeners((listeners)=>{
            pushIfNotFound(mutationListeners, mutationListener);
            return pushIfNotFound(listeners, mutationListener, true);
        });
        return ()=>{
            setAddListeners((listeners)=>{
                spliceIfFound(mutationListeners, mutationListener);
                return spliceIfFound(listeners, mutationListener, true);
            });
        };
    }, []);
    const onRemovedFromDOM = (0,react.useCallback)((listener)=>{
        const mutationListener = (mutations)=>{
            if (mutations.filter((mutation)=>Array.from(mutation.removedNodes).some((node)=>node.isEqualNode(lastValidNode))).length) {
                listener(lastValidNode);
            }
        };
        setRemoveListeners((listeners)=>{
            pushIfNotFound(mutationListeners, mutationListener);
            return pushIfNotFound(listeners, mutationListener, true);
        });
        return ()=>{
            setRemoveListeners((listeners)=>{
                spliceIfFound(mutationListeners, mutationListener);
                return spliceIfFound(listeners, mutationListener, true);
            });
        };
    }, [
        lastValidNode
    ]);
    (0,react.useEffect)(()=>{
        return ()=>{
            for(let idx = 0; idx < addListeners.length; ++idx){
                spliceIfFound(mutationListeners, addListeners[idx]);
            }
            for(let idx1 = 0; idx1 < removeListeners.length; ++idx1){
                spliceIfFound(mutationListeners, removeListeners[idx1]);
            }
        };
    }, [
        addListeners,
        removeListeners
    ]);
    return {
        ref,
        onAddedToDOM,
        onRemovedFromDOM
    };
};
/* harmony default export */ var use_observed_ref = (useObservedRef);

;// CONCATENATED MODULE: ./src/components/base/Menu.tsx




/**
 * Wrapper of the {@link Menu} component that provides callbacks related to DOM
 * mutations.
 */ // eslint-disable-next-line react/display-name
const Menu_Menu = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { onMounted , onUnmounted , ...props } = param;
    const { ref: menuRef , onAddedToDOM , onRemovedFromDOM  } = use_observed_ref(ref);
    (0,react.useEffect)(()=>{
        onAddedToDOM((node)=>{
            return onMounted === null || onMounted === void 0 ? void 0 : onMounted(node);
        });
    }, [
        onAddedToDOM,
        onMounted
    ]);
    (0,react.useEffect)(()=>{
        onRemovedFromDOM((node)=>{
            return onUnmounted === null || onUnmounted === void 0 ? void 0 : onUnmounted(node);
        });
    }, [
        onRemovedFromDOM,
        onUnmounted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
        ref: menuRef,
        ...props
    });
});
Menu_Menu.displayName = "Menu";
/* harmony default export */ var base_Menu = (Menu_Menu);

// EXTERNAL MODULE: ./src/providers/language/index.tsx + 1 modules
var language = __webpack_require__(59915);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/LanguageSwitcher.tsx









const COUNTRY_CODE_MAPPER = {
    vi: "Tiếng Việt",
    en: "English"
};
const LanguageSwitcher = ()=>{
    const amplitude = (0,use_amplitude/* default */.Z)();
    const { lang , handleChangeLanguage  } = (0,react.useContext)(language/* LanguageContext */.A);
    const [activeLang, setActiveLang] = (0,react.useState)(lang);
    const anchorEl = (0,react.useRef)(null);
    const [isOpenLangMenu, setIsOpenLangMenu] = (0,react.useState)(false);
    const handleClick = (0,react.useCallback)(()=>{
        setIsOpenLangMenu(true);
    }, []);
    const handleClose = (0,react.useCallback)(()=>{
        setIsOpenLangMenu(false);
    }, []);
    // const handleToggleTheme = useCallback(() => {
    //   toggleThemeMode()
    //   handleClose()
    // }, [toggleThemeMode, handleClose])
    const handleOnUnmounted = (0,react.useCallback)(()=>{
        if (lang !== activeLang) {
            handleChangeLanguage(activeLang);
        }
    }, [
        activeLang,
        handleChangeLanguage,
        lang
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                id: "btn-preferences-settings",
                size: "small",
                color: "inherit",
                "aria-controls": isOpenLangMenu ? "menu-preferences-settings" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": isOpenLangMenu ? "true" : undefined,
                onClick: handleClick,
                ref: anchorEl,
                "data-testid": "LanguageIcon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: world_icon,
                    alt: "language-icon",
                    width: 30
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_Menu, {
                id: "menu-preferences-settings",
                anchorEl: anchorEl.current,
                open: isOpenLangMenu,
                onClose: handleClose,
                anchorOrigin: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                transformOrigin: {
                    horizontal: "right",
                    vertical: "top"
                },
                MenuListProps: {
                    "aria-labelledby": "btn-preferences-settings"
                },
                onUnmounted: handleOnUnmounted,
                children: Object.keys(COUNTRY_CODE_MAPPER).map((code)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                        selected: lang === code,
                        onClick: ()=>{
                            handleClose();
                            setActiveLang(code);
                            amplitude.track(constants_amplitude/* EVENT_NAMES.page_select_language */.K.page_select_language, {
                                lang: code
                            });
                        },
                        "data-testid": "btn-change-language-to-".concat(code),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: "w-[40px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/lang-".concat(code, "-icon.webp"),
                                    alt: code,
                                    width: 32,
                                    height: 22
                                })
                            }),
                            COUNTRY_CODE_MAPPER[code]
                        ]
                    }, code))
            })
        ]
    });
};
/* harmony default export */ var components_LanguageSwitcher = (LanguageSwitcher);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var icons_material_Menu = __webpack_require__(326);
;// CONCATENATED MODULE: ./src/layouts/components/ExtraMenuItems.tsx









const ExtraMenuItems = ()=>{
    const anchorEl = (0,react.useRef)(null);
    const { isDisplayPendingBadge , pendingTransactions  } = (0,react.useContext)(pending_transactions/* PendingTransactionsCtx */.F);
    const [isOpenMoreMenu, setIsOpenMoreMenu] = (0,react.useState)(false);
    const handleClick = (0,react.useCallback)(()=>{
        setIsOpenMoreMenu(true);
    }, []);
    const handleClose = (0,react.useCallback)(()=>{
        setIsOpenMoreMenu(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                ref: anchorEl,
                id: "menu-more-options",
                onClick: handleClick,
                "data-testid": "btn-extra-menu",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "relative",
                        children: [
                            isDisplayPendingBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute h-4 min-w-[16px] bg-[#FF6701] rounded-full font-bold text-center text-xs pointer-events-none px-[3px] top-[-8px] left-[50%] translate-x-[-50%]",
                                children: pendingTransactions.length
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreHoriz/* default */.Z, {
                                className: classnames_default()("hidden sm:block cursor-pointer opacity-80 hover:opacity-100", isOpenMoreMenu && "opacity-100")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_material_Menu/* default */.Z, {
                        className: classnames_default()("block sm:hidden cursor-pointer opacity-80 hover:opacity-100", isOpenMoreMenu && "opacity-100")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                id: "menu-items-more-options",
                anchorEl: anchorEl.current,
                open: isOpenMoreMenu,
                onClose: handleClose,
                anchorOrigin: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                transformOrigin: {
                    horizontal: "right",
                    vertical: "top"
                },
                MenuListProps: {
                    "aria-labelledby": "menu-more-options"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExtendedMenuItems, {
                    handleClose: handleClose
                })
            })
        ]
    });
};
/* harmony default export */ var components_ExtraMenuItems = (/*#__PURE__*/(0,react.memo)(ExtraMenuItems));

;// CONCATENATED MODULE: ./src/layouts/MainLayout/header/header.desktop.tsx











const HeaderDesktop = ()=>{
    const { data: settingsData  } = (0,use_settings/* useSettings */.r)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: "min-h-[6rem] sm:min-h-[4rem] px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
            color: "transparent",
            className: classnames_default()("shadow-none bg-header", (settingsData === null || settingsData === void 0 ? void 0 : settingsData.is_testnet_mode) && "testnet-mode"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "min-h-[4rem] flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: "flex-wrap w-full h-full py-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            className: "justify-between w-full sm:w-fit sm:justify-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "start",
                                    alignItems: "center",
                                    className: "mr-4 sm:mr-12",
                                    flexShrink: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                                        href: "/",
                                        "data-testid": "header-home-trade",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/logo.svg",
                                            alt: "NemoSwap",
                                            width: "176",
                                            height: "32",
                                            className: "min-w-min"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "start",
                                    alignItems: "center",
                                    spacing: {
                                        sm: 5,
                                        xs: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainMenuItems, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            className: "py-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExtraMenuItems, {})
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            spacing: 2,
                            className: "w-full mt-2 sm:w-fit sm:mt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConnectWallet, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    className: "px-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LanguageSwitcher, {})
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var header_desktop = (/*#__PURE__*/(0,react.memo)(HeaderDesktop));

// EXTERNAL MODULE: ./node_modules/react-use-intercom/dist/index.mjs
var dist = __webpack_require__(41608);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SmsOutlined.js
var SmsOutlined = __webpack_require__(66418);
// EXTERNAL MODULE: ./node_modules/@mui/material/useScrollTrigger/useScrollTrigger.js
var useScrollTrigger = __webpack_require__(8298);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/HideOnScroll.tsx


const HideOnScroll = (param)=>{
    let { children  } = param;
    const trigger = (0,useScrollTrigger/* default */.Z)({
        disableHysteresis: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
        appear: false,
        direction: "down",
        in: !trigger,
        children: children
    });
};
/* harmony default export */ var components_HideOnScroll = (HideOnScroll);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/header/header.mobile.tsx












const HeaderMobile = ()=>{
    const { show  } = (0,dist/* useIntercom */.o)();
    const { data: settingsData  } = (0,use_settings/* useSettings */.r)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: "min-h-[4rem] px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HideOnScroll, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                color: "transparent",
                className: classnames_default()("shadow-none bg-header", (settingsData === null || settingsData === void 0 ? void 0 : settingsData.is_testnet_mode) && "testnet-mode"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: "min-h-[4rem] flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        className: "flex-wrap w-full h-full py-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "start",
                                alignItems: "center",
                                className: "mr-4 sm:mr-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                                    href: "/",
                                    activeHref: "none",
                                    "data-testid": "header-home-trade",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/logo-mobile.svg",
                                        alt: "NemoSwap",
                                        width: "32",
                                        height: "32",
                                        className: "min-w-min"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConnectWallet, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        onClick: show,
                                        "data-testid": "mobile-intercom-launcher",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmsOutlined/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LanguageSwitcher, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var header_mobile = (/*#__PURE__*/(0,react.memo)(HeaderMobile));

;// CONCATENATED MODULE: ./src/layouts/MainLayout/header/index.tsx




const Header = ()=>{
    const isMobile = (0,use_is_mobile/* useIsMobile */.d)();
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(header_mobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(header_desktop, {});
};
/* harmony default export */ var header = (Header);

// EXTERNAL MODULE: ./node_modules/react-just-parallax/dist/esm/index.js
var esm = __webpack_require__(34350);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/NormalBackground.tsx




const NormalBackground = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MouseParallax */.S, {
            isAbsolutelyPositioned: true,
            strength: 0.01,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: "fixed -left-[120px] sm:-left-[130px] top-[40vh] sm:top-[170px] w-[400px] sm:w-[664px]",
                "data-testid": "coin-bubble-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    src: "/ship.webp",
                    placeholderSrc: "/ship_placeholder.webp",
                    alt: "ship",
                    effect: "blur",
                    width: "100%",
                    height: "100%"
                })
            })
        })
    });
};
/* harmony default export */ var MainLayout_NormalBackground = (NormalBackground);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/index.tsx






const MainLayout = (param)=>{
    let { bgPrimary =true , hasNautilus , children  } = param;
    const bgClass = bgPrimary ? "bg-gradient-primary" : "bg-gradient-secondary";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        className: "relative w-full min-h-screen overflow-hidden sm:h-screen bg-center bg-no-repeat bg-cover ".concat(bgClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
            hasNautilus && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_NormalBackground, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "pb-[100px] max-[767px]:pb-[65px] md:pb-0 z-10 flex-1 overflow-auto bg-forest-bottom",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};


/***/ })

}]);